import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "../views/layout/layout";
import Vendor from "../views/masters/vendor/vendor";
import AddVendor from "../views/masters/vendor/add_vendor";
import VendorShare from "../views/masters/vendorShare/vendorShare";
import AddVendorShare from "../views/masters/vendorShare/add_vendorShare";
import VendorGroup from "../views/masters/vendorGroup/vendorGroup";
import AddVendorGroup from "../views/masters/vendorGroup/add_vendorGroup";
import VehicleType from "../views/masters/vehicleType/vehicleType";
import AddVehicleType from "../views/masters/vehicleType/add_vehicleType";
import Users from "../views/masters/users/users";
import AddUsers from "../views/masters/users/add_user";
import Drivers from "../views/masters/drivers/drivers";
import AddConsignor from "../views/masters/consignor/add_consignor";
import Consignor from "../views/masters/consignor/consignor";
import AddConsignee from "../views/masters/consignee/add_consignee";
import Consignee from "../views/masters/consignee/consignee";
import AddSku from "../views/masters/sku/add_sku";
import Sku from "../views/masters/sku/sku";
import SkuType from '../views/masters/skuType/skuType'
import AddDrivers from "../views/masters/drivers/add_drivers";
import AddUserRole from "../views/masters/userRole/userRoleDetail";
import Shipment from "../views/shipment/shipment";
import Dashboard from "../views/dashboard/dashboard";
import Newdashboard from "../views/Newdashboard/newdashboard";
import CreateShipment from "../views/shipment/create_shipment";

import NewOrder from "../views/order/new_order";
import UpdateOrder from "../views/order/edit_order";

import ShipmentDetials from "../components/shipmentComponent/shipmentDetials";
import ActiveOrderDetails from "../components/vendor-login/ordersComponent/ActiveOrderDetails";
import AllotedOrderDetails from "../components/vendor-login/ordersComponent/AllotedOrderDetails";
import ReportingOrderDetails from "../components/vendor-login/ordersComponent/ReportingOrderDetails";
import LoginView from "../views/login/loginview";
import RouteMaster from "../views/masters/route/routeMaster";
import City from "../views/masters/city/city";
import State from "../views/masters/state/state";
import AddRouteMaster from "../views/masters/route/add_route";
import AddCity from "../views/masters/city/add_city";
import UserRole from "../views/masters/userRole/userRole";
import Active_Orders from "../views/vendor-login/ActiveOrders";
import Alloted_Orders from "../views/vendor-login/AllotedOrders";
import Vehicle_Reporting from "../views/vendor-login/VehicleReporting";
import Branch from "../views/masters/branch/branch";
import EwayBill from "../views/eway-bill/eway-bill";
import AddEwayBill from "../views/eway-bill/add-ewaybill"

import ReportSheet from "../views/awsReports/awsReports";

import BillingParty from "../views/masters/billingParty/billingParty";
import AddBillingParty from "../views/masters/billingParty/add_billing_party";
import AddBranches from "../views/masters/branch/add_branches";
import Bill from '../views/vendor-login/bill';
import Tutorial from '../views/vendor-login/tutorial';
import AddBill from '../components/vendor-login/ordersComponent/bill/addBill';
import EditBill from '../components/vendor-login/ordersComponent/bill/editBill';
import ViewBill from '../components/vendor-login/ordersComponent/bill/viewBill';
import vendorProfile from "../components/vendor-login/ordersComponent/myProfile/vendorProfile";
import VehicleAvailability from "../views/masters/vehicleAvailability/vehicleavailability";
import ExportDownload from "../views/masters/exportDownload/ExportDownload";
import VGenerateOrder from "../components/common/generateorderModal";
// redux stuff
import { connect } from "react-redux";
import orders from "../components/orderComponent/orders";
import DeliveryList from "../components/delivery/deliverylist";
import requests from "../components/bookingRequestComponent/request";
import CreateBookingRequest from "../components/bookingRequestComponent/create_booking_request";
import AddAvailability from '../components/vendor-login/ordersComponent/vehicleAvailability/addAvailability';
import OrderPlacement from "../components/orderPlacement/orderPlacement";
import InTransitVehicle from "../components/inTransit/inTransit";
import PlanningReport from "../components/planning/planning";

import HireMemoTable from "../components/hireMemoComponent/hireMemoTable";
import Invoice from '../views/invoice/invoice';
import addSkuType from "../views/masters/skuType/addSkuType";
import yard from "../views/masters/yard/yard";
import AddYard from "../views/masters/yard/add-yard";
import ShippingLine from "../views/masters/shippingLine/shippingLine";
import AddShippingLine from "../views/masters/shippingLine/addShippingLine";

import Cha from "../views/masters/cha/cha";
import addCha from "../views/masters/cha/add_cha";
import Zone from "../views/masters/zone/zone";
import AddZone from "../views/masters/zone/add_zone";
//Permissions based on roles
import { consigneeConsignorCheck, UPL_CUSTOMER, snowmanCustomer } from '../utils/constant'
import SobReport from "../components/SOBReport/SOBReport";
import PurchaseOrder from "../views/vendor-login/purchaseOrder";
import EditPurchaseOrder from "../components/vendor-login/ordersComponent/purchaseOrder/editPurchaseOrder";
import Bank from "../views/masters/bank/bank";
import AddBank from "../views/masters/bank/add_bank";

class Routes extends Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/login"
            exact
            render={(props) =>
              this.props.auth.isAuthenticated ? (
                (this.props.auth.role == 'Vendor' ?
                  <>
                    {UPL_CUSTOMER ?
                      <Redirect to={"/alloted-orders"} />
                      :
                      <Redirect to={"/active-orders"} />
                    }
                  </>
                  :
                  consigneeConsignorCheck(this.props.auth.role) ?
                    <Redirect to={"/deliveries"} /> :
                    <Redirect to={"/shipment"} />
                )
              ) : (
                <LoginView />
              )
            }
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/dashboard"
            component={!consigneeConsignorCheck(this.props.auth.role) && Newdashboard}
          />

          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/home"
            exact
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vendor"
            exact
            component={Vendor}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-vendor"
            exact
            component={AddVendor}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/deliveries"
            exact
            component={DeliveryList}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-vendor"
            exact
            component={AddVendor}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vehicle-generateorder"
            exact
            component={VGenerateOrder}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/my-profile"
            exact
            component={vendorProfile}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/billingParty"
            exact
            component={BillingParty}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add_billing_party"
            exact
            component={AddBillingParty}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vendor-share"
            exact
            component={VendorShare}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-vendor-share"
            exact
            component={AddVendorShare}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-vendor-share"
            exact
            component={AddVendorShare}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vendor-group"
            exact
            component={VendorGroup}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-vendor-group"
            exact
            component={AddVendorGroup}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-vendor-group"
            exact
            component={AddVendorGroup}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vehicle-type"
            exact
            component={VehicleType}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-vehicle-type"
            exact
            component={AddVehicleType}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-vehicle-type"
            exact
            component={AddVehicleType}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-user-role"
            exact
            component={AddUserRole}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-users"
            exact
            component={AddUsers}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-users"
            exact
            component={AddUsers}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/users"
            exact
            component={Users}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-driver"
            exact
            component={AddDrivers}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-driver"
            exact
            component={AddDrivers}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/driver"
            exact
            component={Drivers}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-consignor"
            exact
            component={AddConsignor}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-consignor"
            exact
            component={AddConsignor}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/consignor"
            exact
            component={Consignor}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-consignee"
            exact
            component={AddConsignee}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-consignee"
            exact
            component={AddConsignee}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/consignee"
            exact
            component={Consignee}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/branch"
            exact
            component={Branch}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vehicleavailability"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && VehicleAvailability}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/exportDownload"
            exact
            component={ExportDownload}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-branch"
            exact
            component={AddBranches}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-branch"
            exact
            component={AddBranches}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/state"
            exact
            component={State}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/city"
            exact
            component={City}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-city"
            exact
            component={AddCity}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-city"
            exact
            component={AddCity}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/route"
            exact
            component={RouteMaster}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-route"
            exact
            component={AddRouteMaster}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-route"
            exact
            component={AddRouteMaster}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-product"
            exact
            component={AddSku}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-product"
            exact
            component={AddSku}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/product"
            exact
            component={Sku}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/productType"
            exact
            component={SkuType}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-productType"
            exact
            component={addSkuType}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-productType"
            exact
            component={addSkuType}
          />

          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/cha"
            exact
            component={Cha}
          />

          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/zone"
            exact
            component={Zone}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-zone"
            exact
            component={AddZone}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-zone"
            exact
            component={AddZone}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/bank"
            exact
            component={Bank}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-bank"
            exact
            component={AddBank}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-bank"
            exact
            component={AddBank}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-cha"
            exact
            component={addCha}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-cha"
            exact
            component={addCha}
          />

          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/yard"
            exact
            component={yard}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-yard"
            exact
            component={AddYard}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-yard"
            exact
            component={AddYard}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/shippingLine"
            exact
            component={ShippingLine}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/addShippingLine"
            exact
            component={AddShippingLine}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/editShippingLine"
            exact
            component={AddShippingLine}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/userrole"
            exact
            component={UserRole}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/shipment"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && Shipment}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/orders"
            exact
            component={orders}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/booking-request"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && requests}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/create-booking-request"
            exact
            component={CreateBookingRequest}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-booking-request"
            exact
            component={CreateBookingRequest}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-shipment"
            exact
            component={CreateShipment}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-shipment"
            exact
            component={CreateShipment}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/new-order"
            exact
            component={NewOrder}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-order"
            exact
            component={UpdateOrder}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/shipment-details"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && ShipmentDetials}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/"
            exact
            component={Dashboard}
          />

          {/* Routes for vendor-login */}

          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/active-orders"
            exact
            component={Active_Orders}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/alloted-orders"
            exact
            component={Alloted_Orders}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/active-order-details"
            exact
            component={ActiveOrderDetails}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/alloted-order-details"
            exact
            component={AllotedOrderDetails}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/vehicle-reporting"
            exact
            component={Vehicle_Reporting}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/reporting-order-details"
            exact
            component={ReportingOrderDetails}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/bill"
            exact
            component={Bill}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/tutorial"
            exact
            component={Tutorial}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-bill"
            exact
            component={AddBill}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-bill"
            exact
            component={EditBill}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/PurchaseOrder"
            exact
            component={PurchaseOrder}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/edit-purchaseorder"
            exact
            component={EditPurchaseOrder}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/view-bill"
            exact
            component={ViewBill}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-vehicle"
            exact
            component={AddAvailability}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/order-placement-ratio"
            exact
            component={OrderPlacement}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/in-transit-vehicles"
            exact
            component={InTransitVehicle}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/sob-report"
            exact
            component={SobReport}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/planning"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && PlanningReport}
          />

          //Hire Memo
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/hirememo"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && HireMemoTable}
          />

          //AWS Reports
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/reportsheet"
            exact
            component={ReportSheet}
          />

          //invoice
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/invoice"
            exact
            component={!consigneeConsignorCheck(this.props.auth.role) && Invoice}
          />

          //Eway Bill
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/ewaybill"
            exact
            component={EwayBill}
          />
          <PrivateRoute
            isAuthenticated={this.props.auth.isAuthenticated}
            path="/add-ewaybill"
            exact
            component={AddEwayBill}
          />


        </Switch>
      </React.Fragment>
    );
  }
}
const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <>
            {
              snowmanCustomer ? window.location.href = "https://snowlink.snowman.in/" :
                <Redirect to={"/login"} />
            }
          </>
        )
      }
    />
  );
};

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  };
};
export default connect(mapStateToProps)(Routes);
